import { useMutation } from "@tanstack/react-query";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

//Components
import Questions from "../../../components/Questions/Questions";
import SurveyAdd from "../../../components/Survey/SurveyAdd/SurveyAdd";
import SurveyHeader from "../../../components/Survey/SurveyHeader/SurveyHeader";
import SurveyItems from "../../../components/Survey/SurveyItems/SurveyItems";
import SurveyControls from "../../../components/Survey/SurveyControls/SurveyControls";

//Redux
import {
  DeleteQuestions,
  EditSurveyDescription,
  EditSurveyTitle,
  MoveQuestions,
  SetSelectedQuestions,
  SurveyAddItem,
  SurveyAddItemSpecifixIndex
} from "../../../redux/slice/SurveySlice/SurveySlice";
//APIs
import { postSurvey } from "../../../services/ApiServices";
import Error from "../../Error/Error";

import Layout from "../../../layout/Layout";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";

export default function CreateSurvey() {
  const history = useHistory();
  const Survey = useSelector((state) => state.Survey);
  const dispatch = useDispatch();
  const mutation = useMutation(postSurvey, {
    onSuccess: (value) => {
      toast.success("Anketiniz oluşturuldu.");
      history.push("/home");
    },
    onError: (error) => {
      console.log("error",error);
      if (error.includes("ERR_UPLOAD_EMOJI"))
      {
        console.log("ERR_UPLOAD_EMOJI",error);
      }
      toast.error("Anketiniz oluşturulamadı.");
      return <Error error={error.message} code={error.request.status} />;
    },
  });

  function ListPushSpesific(type, index) {
    switch (type) {
      case "multi":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "multi",
              required: false,
              options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
            },
            index: index,
          })
        );
        break;
      case "single":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "single",
              required: false,
              options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
            },
            index: index,
          })
        );
        break;
      case "input":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "input",
              required: false,
            },
            index: index,
          })
        );
        break;

      case "score":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "score",
              required: false,
            },
            index: index,
          })
        );
        break;
      case "boolean":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "boolean",
              required: false,
              emoji: false,
              options: ["Evet","Hayır"],
            },
            index: index,
          })
        );
        break;
      default:
        break;
    }
  }

  function ListPush(type) {
    switch (type) {
      case "multi":
        dispatch(
          SurveyAddItem({
            title: "Başlık 1",
            question_type: "multi",
            required: false,
            options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
          })
        );
        break;
      case "single":
        dispatch(
          SurveyAddItem({
            title: "Başlık 1",
            question_type: "single",
            required: false,
            options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
          })
        );
        break;
      case "input":
        dispatch(
          SurveyAddItem({
            title: "Başlık 1",
            required: false,
            question_type: "input",
          })
        );
        break;

      case "score":
        dispatch(
          SurveyAddItem({
            title: "Başlık 1",
            required: false,
            question_type: "score",
          })
        );
        break;
      
      case "boolean":
      dispatch(
        SurveyAddItem({
          title: "Başlık 1",
          required: false,
          question_type: "boolean",
          emoji: false, 
          options: ["Evet","Hayır"],
        })
      );
      break;
      default:
        break;
    }
  }

  function SetSelectedItem(index) {
    dispatch(SetSelectedQuestions(index));
  }

  // onClick={() => mutation.mutate(Survey.Survey)}

  return (
    <Layout>
      <div className="w-full min-h-[calc(100vh-50px)] flex items-center  bg-gray-100 flex-col transition-all">
        <div className="application">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Anket Oluştur | Hızlı bir şekilde anket oluştur</title>
          </Helmet>
        </div>

        <div
          className={
            Survey.Survey.questions.length > 0
              ? " px-2 sm:px-4 py-2.5 md:fixed md:inline  z-20 top-14 right-16 border-b border-gray-200 transition-all delay-500 mt-0"
              : "hidden transition-shadow top-0 -mt-10"
          }
        >
          <SurveyControls
            SaveClick={() => mutation.mutate(Survey.Survey)}
            PreviewClick={() => console.log(Survey.Survey)}
          />
        </div>
        <SurveyHeader
          OnChangeTitle={(title) => dispatch(EditSurveyTitle(title))}
          OnChangeDescription={(description) =>
            dispatch(EditSurveyDescription(description))
          }
          title={Survey.Survey.title}
          description={Survey.Survey.description}
        />
        {Survey.Survey.questions.map((element, index) => {
          return (
            <div key={index}>
              <SurveyItems
                key={index}
                index={index}
                surveyLenght={Survey.Survey.questions.length}
                children={
                  <Questions
                    type={element.question_type}
                    title={element.title}
                    description={element.description}
                    emoji={element.emoji}
                    options={element.options}
                    required={element.required}
                    onFocus={() => SetSelectedItem(index)}
                  />
                }
                OnClick={() => SetSelectedItem(index)}
                DeleteQuestions={() => dispatch(DeleteQuestions(index))}
                MoveQuestionsUp={() =>
                  dispatch(MoveQuestions({ index: index, newindex: index - 1 }))
                }
                MoveQuestionsDown={() =>
                  dispatch(MoveQuestions({ index: index, newindex: index + 1 }))
                }
                SurveyAddItem={(value) => ListPushSpesific(value, index + 1)}
              />
            </div>
          );
        })}

        <SurveyAdd AddItemSurvey={(type) => ListPush(type)} />
      </div>
    </Layout>
  );
}
